import { render, staticRenderFns } from "./trans-audit-product-item-report.vue?vue&type=template&id=3fbddb0a&"
import script from "./trans-audit-product-item-report.vue?vue&type=script&lang=ts&"
export * from "./trans-audit-product-item-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports